import Schedule from './component'
export default Schedule
